import React, { useEffect, useState } from "react";
import { RichTreeView } from "@mui/x-tree-view/RichTreeView";
import { Box, Tooltip, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { setSelectedTreeNode } from "../store/cofig_data";
import Spinner from "./ConfigPages/AdminDashboard/Spinner";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ borderRadius: "0px" }}
    >
      {value === index && (
        <Box sx={{ p: 0, borderRadius: "0px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function Organizationtree(props) {
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate
  );
  const orgTree = props?.orgTree;
  const callbackTreePath = props?.callbackTreePath;
  const [treeselected, setTreeselected] = useState([]);
  const [pagesize, setPagesize] = useState(270);
  const [value, setValue] = React.useState(0);
  const [selectedelement, setSelectedelement] = useState();
  const { isLoading } = props;
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();

  // Helper function to strip base64 from Logo for localStorage (too large)
  const stripBase64ForStorage = (nodeData) => {
    if (!nodeData || typeof nodeData !== 'object') return nodeData;
    
    if (Array.isArray(nodeData)) {
      return nodeData.map(item => stripBase64ForStorage(item));
    }
    
    const strippedNode = { ...nodeData };
    
    // Remove base64 from Logo but keep dimensions
    if (strippedNode.Logo && typeof strippedNode.Logo === 'object') {
      strippedNode.Logo = {
        height: strippedNode.Logo.height,
        width: strippedNode.Logo.width
      };
    }
    
    // Process children recursively
    if (Array.isArray(strippedNode.children) && strippedNode.children.length > 0) {
      strippedNode.children = strippedNode.children.map(child => stripBase64ForStorage(child));
    }
    
    return strippedNode;
  };

  useEffect(() => {
    if (overviewstate) {
      setPagesize(160);
    } else {
      setPagesize(316);
    }
  }, [overviewstate]);

  var treeselectdata = {};


  const preprocessTreeData = (treeData) => {
    return treeData.map((node) => ({
      ...node,
      children: Array.isArray(node.children)
        ? preprocessTreeData(node.children)
        : [],
    }));
  };

  useEffect(() => {
    if (orgTree?.length >= 1) {
      const processedTree = preprocessTreeData(orgTree);
      setTreeselected(processedTree);
      treeselectdata = {};
      getselectedtreedata("1", processedTree);
      
      // Store data in Redux WITH logo base64
      props.callbacktreeselect(treeselectdata);
      dispatch(setSelectedTreeNode(treeselectdata));
    }
  }, [orgTree]);

  useEffect(()=>{
      callbackTreePath("Organization List");
  },[])

    const handleitemselected = (event, ids) => {
      treeselectdata = {};
      getselectedtreedata(ids, treeselected);
      setSelectedelement(ids);
      const treePath=getBreadcrumbPath(treeselected, ids);
      callbackTreePath(treePath);
      
      // Store data WITH logo base64
      props.callbacktreeselect(treeselectdata);
      dispatch(setSelectedTreeNode(treeselectdata));
  };

    const getselectedtreedata = (id, treejson) => {
      for (let i = 0; i < treejson?.length; i++) {
        const node = treejson[i];
        if (!node) continue; 

        if (Array.isArray(node.children) && node.children.length !== 0) {
          if (node.id === id) {
            treeselectdata = node;
            return;
          } else {
            getselectedtreedata(id, node.children);
          }
        } else {
          if (node.id === id) {
            treeselectdata = node;
            return;
          }
        }
      }
    };

  // Helper to find node by id in tree
  const findNode = (treeData, nodeId) => {
    for (const node of treeData) {
      if (node.id === nodeId) {
        return node;
      }
      if (node.children && node.children.length) {
        const foundNode = findNode(node.children, nodeId);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  };

  // Helper to get breadcrumb path for a node id
  const getBreadcrumbPath = (treeData, nodeId, path = []) => {
    for (const node of treeData) {
      if (node.id === nodeId) {
        return [...path, node];
      }
      if (node.children && node.children.length) {
        const result = getBreadcrumbPath(node.children, nodeId, [...path, node]);
        if (result.length) return result;
      }
    }
    return [];
  };

  return (
    <Box sx={{ width: "218px", borderRadius: 0, marginRight: "16px" }}>
      <Box sx={{ backgroundColor: "var(--PrimaryBackground)" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            "& .MuiTabs-indicator": { display: "none" },
            "& .Mui-selected": {
              backgroundColor: "var(--SecondaryBackground)",
              color: "var(--LK_BrandBlue_1) !important",
              fontWeight: "700 !important",
              border: "1px solid var(--HighlightedText_Stroke)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            minHeight: "30px",
            marginBottom: "-1px",
          }}
        >
          {["Configuration", ""].map((label, index) => (
            <Tab
              key={index}
              label={label}
              {...a11yProps(index)}
              sx={{ minHeight: "30px", height: "30px" }}
              style={{
                color: "var(--GreyVariation_2)",
                fontFamily: "Roboto",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "16.41px",
                textTransform: "capitalize",
                flexGrow: 1,
              }}
            />
          ))}
        </Tabs>
      </Box>
      <Box
        sx={{
          width: "216px",
          border: "1px solid var(--HighlightedText_Stroke)",
          height: `calc(100vh - ${pagesize}px)`,
          backgroundColor: "var(--SecondaryBackground)",
          overflow: "auto",
        }}
      >
        <CustomTabPanel value={value} index={0} style={{ overflow: "auto" }}>
          <Box
            sx={{
              height: "100%",
              textAlign: "left",
              margin: "10px",
              overflow: "auto",
            }}
          >
            <Tooltip>
              {treeselected && treeselected.length > 0 && (
                <RichTreeView
                  sx={{
                    "& .MuiTreeItem-group": {
                      color: "var(--action-button-light) !important",
                      fontWeight: "700 !important",
                    },
                    "& .Mui-selected:hover": {
                      backgroundColor: "transparent !important",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "transparent !important",
                      color: "#008CD7 !important",
                      fontWeight: "900 !important",
                    },
                    "& .MuiTreeItem.Mui-focused": {
                      backgroundColor: "transparent !important",
                      color: "var(--action-button-light) !important",
                      fontWeight: "700 !important",
                    },
                    "& .MuiTreeItem-label": {
                      fontSize: "16px",
                      fontWeight: 400,
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    },
                    color: "var(--PrimaryText)",
                  }}
                  aria-label="customized"
                  items={treeselected}
                  getItemLabel={(node) =>
                    node
                      ? node.Label ||
                        node.label ||
                        node.Organizationname ||
                        node.Projectname ||
                        "NO name"
                      : "NO name"
                  }
                  onSelectedItemsChange={handleitemselected}
                  getItemId={(node) =>
                    node
                      ? node.id || node.Organizationid || node.Projectid || ""
                      : ""
                  }
                  defaultExpanded={["root"]}
                />
              )}
              {isLoading && <Spinner size="40px" color="blue" speed="0.8s" />}
            </Tooltip>
          </Box>
        </CustomTabPanel>
      </Box>
    </Box>
  );
}
